import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { featureToggleGuard } from 'ish-core/feature-toggle.module';

import { dotCmsUvePathProtectionGuard } from '../guards/dot-cms-uve-path-protection.guard';
import { matchDotCMSPageRoute } from '../routing/dot-cms-page-route';
import { DotCmsDefaultPageComponent } from '../shared/dot-cms-default-page/dot-cms-default-page.component';

const routes: Routes = [
  {
    path: 'homepage',
    component: DotCmsDefaultPageComponent,
    data: { wrapperClass: 'dotcms-home' },
  },
  {
    path: 'dot-cms-page', //Don't add wildcard route here
    children: [
      {
        path: '**',
        component: DotCmsDefaultPageComponent,
        data: { wrapperClass: 'dotcms-page' },
        canActivate: [dotCmsUvePathProtectionGuard],
      },
    ],
  },
];

export const icsaLastRoutes: Routes = [
  {
    matcher: matchDotCMSPageRoute,
    canActivate: [featureToggleGuard],
    data: { feature: 'dotCms' },
    loadChildren: () => DotCmsRoutingModule,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DotCmsRoutingModule {}
